export const getBackendUrl = () => {
    if (process.env.NODE_ENV === 'development' || !process.env.NODE_ENV) {
        return process.env.REACT_APP_SERVER_URL_STAGING
    }
    return process.env.REACT_APP_SERVER_URL
}

const SERVER_URL = getBackendUrl()

export const VALIDATE_OTP_REGISTRATION = `${SERVER_URL}/register`
export const SEND_OTP = `${SERVER_URL}/send-otp`
export const LOGIN_API = `${SERVER_URL}/login`
export const CREATE_BOOKING = `${SERVER_URL}/bookings/create`
export const GET_BOOKINGS = `${SERVER_URL}/bookings`
export const GET_JOB_TYPES = `${SERVER_URL}/job-type/formatted`
export const REFRESH_TOKEN = `${SERVER_URL}/refresh-token`

export const getProfilesFromStatusAPI = (bookingId, status) =>
    `${SERVER_URL}/bookings/${bookingId}/hiring-details/status/${status}`

export const getWorkerDetailsAPI = (workerId, bookingId) => `${SERVER_URL}/workers/${workerId}?bookingId=${bookingId}`

export const getWorkProfileAPI = (workerId, bookingId) =>
    `${SERVER_URL}/workers/${workerId}?status=work&bookingId=${bookingId}`

export const getFinancialDataAPI = (workerId, bookingId) =>
    `${SERVER_URL}/workers/${workerId}?status=finance&bookingId=${bookingId}`
